<template>
    <div class="aside-menu" id="asideMenuJS" style="display: none;">
        <swiper :options="swiperOption" class="swiper-container-free-mode" ref="asideMenuSwiper2" id="asideMenuSwiper">
            <!-- slides -->
            <swiper-slide>
                <div class="content-wrapper">
                    <div class="content-inner">
                        <nav v-if="!loading" class="page-nav">
                            <ul class="page-nav__menu-list">
                                <li v-for="parentMenu in menu" :key="parentMenu.id">
                                    <router-link :to="'/'+parentMenu.route">{{parentMenu.title}}</router-link>
                                    <ul v-if="parentMenu.categories.length > 1" class="page-nav__submenu-list">
                                        <li v-for="category in parentMenu.categories" :key="category.id">
                                            <router-link :to="{ name: parentMenu.route, params: { category: category.props } }">{{category.title}}</router-link>
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    <a>Language</a>
                                    <ul class="page-nav__submenu-list">
                                        <li><a @click.prevent="changeLanguage('en')" :class="{ 'site-lang_en': true, 'active' : this.lang === 'en'}" href="#">English</a></li>
                                        <li><a @click.prevent="changeLanguage('es')" :class="{ 'site-lang_es': true, 'active' : this.lang === 'es'}" href="#">Español</a></li>
                                    </ul>
                                </li>
                            </ul>

                            <footer class="menu-footer">
                                <span><router-link :to="{ name : 'privacy' }">{{$t('privacy')}}</router-link></span>
                            </footer>
                        </nav>
                    </div>
                </div>
            </swiper-slide>
            <!-- Optional controls -->
            <div class="swiper-scrollbar" slot="scrollbar" id="asideMenuScrollbar"></div>
        </swiper>
    </div>
</template>

<script>
    import {i18n} from '../plugins/i18n';
    import {  scrollEnable } from '../outer-js'
    import { mapGetters } from 'vuex'
    import { mapActions } from 'vuex';
    export default {
        name: "AsideMenu",
        data (){
            return {
                swiperOption: {
                    direction: 'vertical',
                    slidesPerView: 'auto',
                    freeMode: true,
                    scrollbar: {
                        el: '.swiper-scrollbar',
                    },
                    mousewheel: true,
                },
            }
        },
        computed:{
            ...mapGetters({
                menu: 'getMenu',
                loading: 'getLoading',
                lang: 'getLang',
            })
        },
        watch: {
            loading: function (oldVal, newVal) {
                if(newVal){
                    this.initSlider();
                }
            },
        },
        methods:{
            ...mapActions({
                setLocale: 'setLocaleAsync',
            }),
            initSlider(){
                $('#asideMenuJS').on('click', 'a', function () {
                    $('#asideMenuJS').fadeOut();
                    $('#menuIcon').removeClass('active');
                    scrollEnable();
                });
            },
            changeLanguage(lang){
                i18n.locale = lang;
                this.setLocale(lang);
            },
        },
    }
</script>

<style scoped>

</style>